import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserViewService } from '../../../../../shared/sub-modules/user-views/services/user-view.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';

/** HistoricalOthersService */
@Injectable()
export class HistoricalOtherAddressService extends UserViewService {
  urlBase = environment.urlPickups;
  /** HistoricalOthersService */
  constructor(http: HttpClient) {
    super('historical-other-address', http);
  }

  /** Obtiene las delegaciones */
  listOfAgency(): Observable<Array<any>> {
    return this.http.get<Array<any>>(this.url('agency-list'));
  }
}
